export const APP_VERSION = import.meta.env.PACKAGE_VERSION;
export const DISCORD_LINK = "";
export const GITHUB_LINK = "";
export const TWITTER_LINK = "https://twitter.com/coolmoviez";
export const GA_ID = import.meta.env.VITE_GA_ID;
export const BACKEND_URL = import.meta.env.VITE_BACKEND_URL;
// Do it clap??
